export const solutionsList = [
  {
    image: '/assets/images/careers/quality-input',
    heading: 'Quality Input',
    desc: 'Premium quality agri-input products for farmers, help them achieve healthier & high-yielding crops.',
  },
  {
    image: '/assets/images/careers/market-access',
    heading: 'Profitable Market Access',
    desc: 'Linking farmers to profitable markets for better rates, convenient business and higher earnings.',
  },
  {
    image: '/assets/images/careers/health-insurance',
    heading: 'Affordable Insurance',
    desc: 'Insurances for farmers at very reasonable prices to mitigate their crop losses, and provide monetary stability.',
  },
  {
    image: '/assets/images/careers/credit',
    heading: 'Formal Credit',
    desc: 'Easy repayment options and convenient documentation for splendid credit facilities at reasonable charges.',
  },
  {
    image: '/assets/images/careers/delivery',
    heading: 'Door Step Delivery',
    desc: 'Farmers can conveniently get the required agri-product delivered through our DeHaat Kisan App.',
  },
  {
    image: '/assets/images/careers/advisory',
    heading: 'Actionable Advisory',
    desc: 'Free and top-notch agricultural guidance by our Agri-experts to help farmers harvest better yields & select the right quality products.',
  },
]

export const dehaatNumbers = [
  {
    value: '1818+',
    title: 'No. of Employees',
  },
  {
    value: '12+',
    title: 'No. of operational offices',
  },
  {
    value: '12+',
    title: 'Presence in No. of States',
  },
  {
    value: '18L +',
    title: 'No. of Farmers',
  },
]

export const workingBenefits = [
  {
    image: '/assets/images/careers/health-insurance',
    heading: 'Health Insurance',
    desc: 'Market leading health insurance benefits provide comprehensive coverage for medical expenses, ensuring financial security for you and your family.',
  },
  {
    image: '/assets/images/careers/learning',
    heading: 'Learning & Development',
    desc: `Informative sector related courses available at our L&D 
    platform DeHaat Academy for employees to explore, 
    learn & grow.`,
  },
  {
    image: '/assets/images/careers/flexi-benefits',
    heading: 'Flexi Benefits',
    desc: 'Flexi benefits for employees allow for customized compensation packages that cater to individual needs, promoting a healthy work-life balance.',
  },
  {
    image: '/assets/images/careers/fitness',
    heading: 'Health Focused Activity',
    desc: `Health-focused activities for employees promote wellness, 
    boost morale, and improve productivity, creating a happier, healthier & productive workplace.`,
  },
]

export const dehaatLifeImages = [
  {
    image: '/assets/images/careers/dehaat_life1',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life2',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life3',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life4',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life5',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life6',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life7',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life8',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life9',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life10',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life11',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life12',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life13',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life14',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life15',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life16',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life17',
    alt: '',
  },
  {
    image: '/assets/images/careers/dehaat_life18',
    alt: '',
  },
]

export const workCultureImages = [
  { image: '/assets/images/careers/workCulture1', alt: '' },
  { image: '/assets/images/careers/workCulture3', alt: '' },
  { image: '/assets/images/careers/workCulture5', alt: '' },
  { image: '/assets/images/careers/workCulture12', alt: '' },
  { image: '/assets/images/careers/work_culture4', alt: '' },
  { image: '/assets/images/careers/work_culture6', alt: '' },
  { image: '/assets/images/careers/workCulture10', alt: '' },
  { image: '/assets/images/careers/work_culture2', alt: '' },
]

export const founders = [
  {
    image: '/assets/images/careers/founder1',
    name: 'Shashank Kumar',
    designation: 'CEO & Co-Founder',
    linkedin_link: 'https://www.linkedin.com/in/shashank-kumar-798b258/',
    twitter_link: 'https://twitter.com/ShashankFnF',
  },
  {
    image: '/assets/images/careers/founder2',
    name: 'Shyam Sundar Singh',
    designation: 'Executive  Director & Co-Founder',
    linkedin_link: 'https://www.linkedin.com/in/shyam-sundar-singh-94b0799/',
    twitter_link: 'https://twitter.com/9shyams',
  },
  {
    image: '/assets/images/careers/founder3',
    name: 'Amrendra Singh',
    designation: 'Director & Co-Founder',
    linkedin_link: 'https://www.linkedin.com/in/amrendra-singh-64922436/',
    twitter_link: 'https://twitter.com/AmrendraFnF',
  },
  {
    image: '/assets/images/careers/founder4',
    name: 'Adarsh Srivastava',
    designation: 'Director & Co-Founder',
    linkedin_link: 'https://www.linkedin.com/in/adarsh-srivastava-902008b1/',
    twitter_link: 'https://twitter.com/Adarsh_ISM',
  },
]

export const aboutDehaat = [
  `360° Agri Tech-enabled solutions`,
  'Great Work Culture',
  'Innovation & Creativity',
  'Promising Growth',
]

export const testimonialsList = [
  {
    videoLink:
      'https://kheti-cdn.agrevolution.in/WhatsApp%20Video%202023-02-15%20at%203.32.02%20PM.mp4',
    thumbnailUrl: '/assets/images/careers/testimonial1.webp',
  },
  {
    videoLink:
      'https://kheti-cdn.agrevolution.in/05119a5a-0f55-11ee-be56-0242ac120002.mov',
    thumbnailUrl: '/assets/images/careers/testimonial2.webp',
  },
  {
    videoLink:
      'https://kheti-cdn.agrevolution.in/f80ad506-0f54-11ee-be56-0242ac120002.mp4',
    thumbnailUrl: '/assets/images/careers/testimonial3.webp',
  },
]
